// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"5565ef95","582":"50e455ff","747":"2e4dbee2","977":"c0c0acd2","996":"e39bbb1d"}[chunkId] + ".chunk.js";
};